import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/overlay';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  readonly dialog = inject(MatDialog);

  openDialog<T, D = unknown>(component: ComponentType<T>, data?: D): Observable<T> {
    const dialogRef = this.dialog.open(component, {
      width: '50vw',
      data
    });
    return dialogRef.afterClosed();
  }

  openTypedDialog<T, D = unknown, R = unknown>(
    component: ComponentType<T>,
    data?: D,
    config?: Omit<MatDialogConfig<D>, 'data'>
  ): Observable<R | undefined> {
    const dialogRef: MatDialogRef<T, R> = this.dialog.open<T, D, R>(component, {
      data,
      width: '50vw',
      ...config
    });
    return dialogRef.afterClosed();
  }
}
